import { generatePath } from 'react-router';
import { request } from '@lib/request';
import { FetchMerchantInfoParamsDto, MerchantInfoType } from '@api/merchant-info/merchant-info.dto';

const FETCH_MERCHANT_INFO = '/merchant-settings/v2/merchant-info/:publicId';

export const fetchMerchantInfo = async ({ publicId }: FetchMerchantInfoParamsDto) => {
    const result = await request.get<MerchantInfoType>(generatePath(FETCH_MERCHANT_INFO, { publicId }));
    return result.data;
};
